import React from "react";
import "./Button.css";

interface ButtonProps {
  text: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  type?: "submit" | "reset" | "button";
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  loading?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  text,
  onClick,
  type,
  endIcon,
  loading = false,
}) => {
  return (
    <div className="button-wrapper">
      <button
        className={`custom-button ${loading ? "loader-btn" : ""}`}
        type={type}
        disabled={loading}
        onClick={onClick}
      >
        {loading ? (
          <p>
            <span className="button-loader">
              <span></span>
              <span></span>
              <span></span>
            </span>
          </p>
        ) : (
          <>
            <span>{text}</span>
            {endIcon && (
              <span className="button-wrapper-endIcon">{endIcon}</span>
            )}
          </>
        )}
      </button>
    </div>
  );
};

export default Button;
